var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"vmp-brush-popup"},[_c('div',{staticClass:"list-container"},[_vm._t("top"),_c('div',{staticClass:"item-list"},[_vm._t("item")],2),_c('div',{staticClass:"color-list"},[_vm._t("color")],2)],2)])
}
var staticRenderFns = []

export { render, staticRenderFns }